module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAECAYAAACzzX7wAAAAAXNSR0IArs4c6QAAAHlJREFUGFdj5Ej4uJThH9OcH4t49zMgAY64944MzEypjAyxn8U4mP+tYWD4N/vHAsHFIDVscR9jmJgY0n78ZQphBGvyfcbFLsS1hJGJ+RzDP4b//5n+G/988yWGYbPUN4gCEGj4z8T58FM/w38Gxu8KfAUMDYz/QMIA/W8nawbtbxQAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/h5-down.png
// module id = t3hs
// module chunks = 1